import mainImg from './mainImage.png';
import { BlockPage } from '../../../routings/pages/BlockPage/BlockPage';
import { Icons } from '@silverfort/sf-components';

export const CloudITDRBlockedPage = () => {
    const topics = [
        'Visualize all parts of an attack across your previously siloed IdPs, in one place',
        'Identify and block threats, like credential theft and lateral movement, in your cloud environments',
        'Automate responses, like account lockdown and threat isolation'
    ];

    return (
        <BlockPage
            leftContent={{
                title: 'Identity Threat Detection and Response',
                image: mainImg
            }}
            rightContent={{
                icon: Icons.Target,
                title: 'Fortify Your Cloud Identities with ITDR',
                description:
                    'Detect and respond to identity-based threats in real time, overseeing cloud authentications and access attempts.',
                topics: topics,
                accessLink: 'https://www.silverfort.com/cloud-itdr-signup/?utm_source=PQL&utm_content=main'
            }}
        />
    );
};
